const isProduction = !(!process.env.NODE_ENV || process.env.NODE_ENV === 'development');

const config = {
  adClientId: process.env.REACT_APP_AD_CLIENT_ID,
  adTenantId: process.env.REACT_APP_AD_TENANT_ID,
  apimSubscriptionKey: process.env.REACT_APP_APIM_SUBSCRIPTION_KEY,
  basePath: '/',
  basePathPlatformDacAPI: process.env.REACT_APP_API_BASEPATH_DAC,
  basePathPlatformUsrMgtAPI: process.env.REACT_APP_API_BASEPATH_CSAPPS_USERMGT,
  basePathPlatformSupAPI: process.env.REACT_APP_API_BASEPATH_CSAPPS_SUP,
  basePathPlatformSubsAPI: process.env.REACT_APP_API_BASEPATH_CSAPPS_SUBS,
  basePathPlatformAppMgtAPI: process.env.REACT_APP_API_BASEPATH_CSAPPS_APPMGT,
  notificationAPI: process.env.REACT_APP_API_BASEPATH_CSNOTIFY_APPMGT,
  footerHeight: '56px',
  headerHeight: '72px',
  isProduction,
  logAuth: false,
  platformCommonScope: process.env.REACT_APP_API_SCOPE_CSAPPS_USERMGT,
  productName: 'Worley Digital Platform',
  stagingEnv: process.env.REACT_APP_STAGING_ENV || 'dev',
  productList: [
    {
      name: 'WC',
      url: process.env.REACT_APP_BASEPATH_WORLEY_CONSULTING,
    },
    {
      name: 'PD',
      url: process.env.REACT_APP_BASEPATH_PROJECT_DELIVERY,
    },
    {
      name: 'DAC',
      url: process.env.REACT_APP_BASEPATH_DAC_ARTEMIS,
    },
    // {
    //   name: 'GenAI',
    //   url: process.env.REACT_APP_BASEPATH_GEN_AI,
    // },
    // {
    //   name: 'Corporate',
    //   url: process.env.REACT_APP_BASEPATH_CORPORATE_APPLICATIONS,
    // },
  ],
};

export default config;
